import React from "react";

import { FlexDiv } from "@/components/Atoms/Box";

import LikeButton from "@/components/Molecules/LikeButton";
import BookmarkButton from "@/components/Molecules/BookmarkButton";
import Poll from "./Poll";

import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

import {
  ActionButton,
  Avatar,
  Duration,
  FollowButton,
  Name,
  PostActions,
  PostBanner,
  PostContent,
  PostMetadata,
  PostTitle,
  UserAvatar,
  UserData,
  UserIcon,
  UserInfo,
  UserType,
  VerificationBadge,
} from "./style";

const Post = ({ postDetail, showBanner }) => {
  const {
    text: title,
    topic,
    posted_by,
    created_timestamp,
    description,
    number_of_likes: likes,
    number_of_comments: comments,
    number_of_bookmarks: bookmarks,
    cover_image_link: coverImage,
    is_liked_by_user: isLiked,
    is_bookmarked_by_user: isBookmarked,
    type,
    total_vote: votes,
    threadoption_set: pollOptions,
    total_days_remaining: pollDurationData,
  } = postDetail || {};

  const Chip = topic && (
    <FlexDiv
      px="16px"
      py="4px"
      backgroundColor={theme.colorsV2.blueGray.shade_100}
      width="max-content"
      borderRadius="50px"
    >
      <Typography
        variant="label4"
        fontSize="10px"
        lineHeight="16px"
        fontFamily="var(--man-700)"
        color={theme.colorsV2.blueGray.shade_500}
      >
        {topic?.title || ""}
      </Typography>
    </FlexDiv>
  );

  const MetaData = (
    <PostMetadata>
      <UserInfo>
        {posted_by?.profile_picture ? (
          <Avatar src={posted_by?.profile_picture} />
        ) : (
          <UserAvatar>
            <UserIcon icon="icon-user-avatar" />
          </UserAvatar>
        )}
        <UserData>
          <FlexDiv style={{ gap: "4px", alignItems: "center" }}>
            <Name
              variant="label3"
              fontSize="14px"
              lineHeight="20px"
              fontFamily="var(--man-700)"
            >
              {posted_by?.customer_name}
            </Name>
            {posted_by?.is_verified && <VerificationBadge icon="icon-verify" />}
            <Name
              variant="label3"
              fontSize="14px"
              lineHeight="20px"
              fontFamily="var(--man-700)"
              onClick={showBanner}
            >
              &#x2022;
            </Name>
            <FollowButton
              variant="label3"
              fontSize="14px"
              lineHeight="20px"
              fontFamily="var(--man-700)"
              onClick={showBanner}
            >
              Follow
            </FollowButton>
          </FlexDiv>
          <FlexDiv style={{ gap: "4px", alignItems: "center" }}>
            {posted_by?.user_type && (
              <>
                <UserType
                  variant="label3"
                  fontSize="12px"
                  lineHeight="16px"
                  fontFamily="var(--man-700)"
                  onClick={showBanner}
                  isShyftUser={
                    posted_by?.user_category?.toLowerCase() === "shyft_expert"
                  }
                >
                  {posted_by?.user_type}
                </UserType>
                <Duration
                  variant="label4"
                  fontSize="12px"
                  lineHeight="16px"
                  fontFamily="var(--man-700)"
                >
                  &#x2022;
                </Duration>
              </>
            )}
            <Duration
              variant="label4"
              fontSize="12px"
              lineHeight="16px"
              fontFamily="var(--man-700)"
            >
              {created_timestamp?.display_timestamp || ""}
            </Duration>
          </FlexDiv>
        </UserData>
      </UserInfo>
    </PostMetadata>
  );

  const Title = (
    <PostTitle
      variant="heading5"
      fontSize="18px"
      lineHeight="24px"
      fontFamily="var(--man-700)"
    >
      {title}
    </PostTitle>
  );

  const Content =
    type?.toLowerCase() === "poll" ? (
      <Poll
        votes={votes}
        pollOptions={pollOptions}
        pollDurationData={pollDurationData}
        onClick={showBanner}
      />
    ) : (
      <PostContent content={description} onUserProfileClick={showBanner} />
    );

  const Banner = coverImage && (
    <FlexDiv justifyContent="center" alignItems="center">
      <PostBanner src={coverImage} />
    </FlexDiv>
  );

  const Actions = (
    <PostActions>
      <LikeButton isLiked={isLiked} setIsLiked={showBanner} count={likes} />
      <ActionButton
        icon="icon-message"
        iconHeight="16px"
        iconWidth="16px"
        onClick={showBanner}
      >
        <Typography
          variant="label3"
          fontSize="14px"
          lineHeight="20px"
          fontFamily="var(--man-600)"
        >
          {comments} Comment{comments > 1 ? `s` : ""}
        </Typography>
      </ActionButton>
      <BookmarkButton
        isBookmarked={isBookmarked}
        setIsBookmarked={showBanner}
        count={bookmarks}
      />
    </PostActions>
  );

  return (
    <>
      {Chip}
      {MetaData}
      {Title}
      {Content}
      {Banner}
      {Actions}
    </>
  );
};

export default Post;
